import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { saveConfig, updateSelectedOptions } from '../../FilterActions';
import { CustomMultiselect, withColorRenderer } from '../common';

class LocalHealthZones extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItems: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items != this.props.items) {
      this.setState({
        items: this.props.items,
      });
    }

    if (prevProps.selectedItems != this.props.selectedItems) {
      this.setState({
        selectedItems: this.props.selectedItems,
      });
    }
  }

  updateState() {
    this.setState({
      items: this.props.items,
      selectedItems: this.props.selectedItems,
    });
  }

  handleChange(selected) {
    let ordered = _.orderBy(selected);
    this.props.updateSelectedOptions(ordered);
    this.props.saveConfig();
  }

  render() {
    const { items, selectedItems } = this.state;

    return (
      <CustomMultiselect
        name={'Health zones'}
        items={items}
        selectedItems={selectedItems}
        onSelect={this.handleChange}
        itemRenderer={withColorRenderer}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateSelectedOptions: (vals) => dispatch(updateSelectedOptions('healthZones', vals)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    items: state.filters.allHealthZones,
    selectedItems: state.filters[chart].selectedHealthZones,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(LocalHealthZones);
export { connected as LocalHealthZones };
